import {ACTION_TYPE, EDITORMODE} from "utils/constants";
import produce from "immer";

const initialState = {
  isOpen: false,
  editorMode: EDITORMODE.BLOCK,
  currentScript: {},
  showScriptList: false,
};

const codeEditor = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.SET_CODE_EDITOR:
      return produce(state, draft => {
        draft.isOpen = action.bool;
      });
    case ACTION_TYPE.SET_CODE_EDITOR_MODE:
      return produce(state, draft => {
        draft.editorMode = action.mode;
      });
    case ACTION_TYPE.SET_CURRENT_SCRIPT:
      return produce(state, draft => {
        draft.currentScript = action.script;
        draft.showScriptList = false;
      });
    case ACTION_TYPE.SHOW_SCRIPT_LIST:
      return produce(state, draft => {
        draft.showScriptList = action.bool;
      });
    default:
      return state;
  }
};

export default codeEditor;
